export const checkOrgAndNotLoggedIn = (orgArray = [], isLogged = false) => {
  return orgArray.includes(process.env.REACT_APP_COD_ORGANIZACION) && !isLogged;
};

export const checkOrg = (orgArray = []) => {
  return orgArray.includes(process.env.REACT_APP_COD_ORGANIZACION);
};

export const oneLineStyles = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
};

export const formatPrice = (price) => {
  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
};

export const requireCuil = (requiereCuil, cuil) => {
  return requiereCuil && Boolean(requiereCuil) === true && (cuil === null || cuil === "")
}